<template>
    <v-app>
        <Toolbar title="TID Logon"/>
        <v-content>
            <v-layout row>
                <v-flex xs12 sm12 offset-sm0>
                    <v-card>
                        <v-card-title primary-title>
                            <v-btn @click="$router.push({path: '/groups'})">
                                <v-icon dark>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>

        </v-content>
    </v-app>
</template>

<script>
    import Toolbar from '../components/Toolbar'
    const fb = require('../firebase')

    export default {
        name: "TidLogon",
        components: {Toolbar},
        data () {
            return {
                search: '',
                rowsPerPage: [25, 50, 100, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
                aibmsHeaders: [
                    {text: 'Tacq', align: 'left', sortable: false},
                    {text: 'TID', align: 'left', sortable: true, value: 'tid'},
                    {text: 'Terminal Provider', align: 'left', sortable: false},
                    {text: 'APACS Type', align: 'left', sortable: false},
                    {text: 'Currency', align: 'left', sortable: true, value: 'currency'},
                    {text: 'Log On/Off', align: 'left', sortable: false},
                    {text: 'Trading Name', align: 'left', sortable: true, value: 'business'},
                    {text: 'New Merchant Number', align: 'left', sortable: true, value: 'mid'},
                    {text: 'Complete', align: 'left', sortable: false}
                ],
                barclaysHeaders: [
                    {text: 'TID', align: 'left', sortable: true, value: 'tid'},
                    {text: 'Terminal Provider', align: 'left', sortable: false},
                    {text: 'APACS Type', align: 'left', sortable: false},
                    {text: 'Currency', align: 'left', sortable: true, value: 'currency'},
                    {text: 'Trading Name', align: 'left', sortable: true, value: 'business'},
                    {text: 'New Merchant Number', align: 'left', sortable: true, value: 'mid'},
                    {text: 'Complete', align: 'left', sortable: false}
                ],
                aibms: [],
                barclaycard: []
            }
        },
        mounted () {
            this.fetchAIBMS()
            this.fetchBarclaycard()
            // this.checkDevices()
        },
        methods: {
            fetchAIBMS: function () {
                fb.settingsCollection
                    .where('terminal.host', '==', 'aibms')
                    .where('merchant.logon', '==', false)
                    .get()
                    .then((settings) => {
                        settings.forEach((setting) => {
                            let dd = setting.data()
                            if (dd['merchant.merchantid'] !== '010003382') {
                                dd['id'] = setting.id
                                this.aibms.push(dd)
                            }
                        })
                    })
            },
            fetchBarclaycard: function() {
                fb.settingsCollection
                    .where('terminal.host', '==', 'barclays')
                    .where('merchant.logon', '==', false)
                    .get()
                    .then((settings) => {
                        settings.forEach((setting) => {
                            let dd = setting.data()
                            dd['id'] = setting.id
                            this.barclaycard.push(dd)
                        })
                    })
            }
        }

    }
</script>

<style scoped>

</style>
